import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  container: { position: 'relative' }
});

export default makeStyles(styles);
